import type {
  Categories,
  OtPurpose,
  OtPurposeByCategory,
  OtPurposeBySteps,
  OtPurposeByUUID,
  OtPurposesByCategoryAndUser,
  OtPurposesByStepsAndUser,
  Steps,
} from "@jti/fe-common";

import { CasBaseApi } from "../../CasBaseApi";
import type { CasPurposesApiContract, ConsentPayload } from "../CasPurposesApi.types";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class CasPurposesApiLegacy extends CasBaseApi implements CasPurposesApiContract {
  readonly name = "CasPurposesApi";
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string,
    protected userUuid: string,
    protected lang: string
  ) {
    super(baseUrl, tenantToken, ciamToken);
  }

  async getPurposesByStep(step: "all", isCached?: boolean): Promise<OtPurposeBySteps[]>;
  async getPurposesByStep(step: Steps, isCached?: boolean): Promise<OtPurpose[]>;
  async getPurposesByStep(step: Steps, isCached = true): Promise<(OtPurposeBySteps | OtPurpose)[]> {
    const uri = `/purposes?language=${this.lang}&step=${step}`;
    const { data } = await this.request<(OtPurposeBySteps | OtPurpose)[]>(uri, {}, true, isCached);

    return data;
  }

  async getPurposesByCategory(category: "all", isCached?: boolean): Promise<OtPurposeByCategory[]>;
  async getPurposesByCategory(category: Categories, isCached?: boolean): Promise<OtPurpose[]>;
  async getPurposesByCategory(category: Categories, isCached = true): Promise<(OtPurposeByCategory | OtPurpose)[]> {
    const uri = `/purposes?language=${this.lang}&category=${category}`;
    const { data } = await this.request<(OtPurposeByCategory | OtPurpose)[]>(uri, {}, true, isCached);

    return data;
  }

  async getPurposesForUserByStep(step: "all", isCached?: boolean): Promise<OtPurposesByStepsAndUser[]>;
  async getPurposesForUserByStep(step: Steps, isCached?: boolean): Promise<OtPurposeByUUID[]>;
  async getPurposesForUserByStep(
    step: Steps,
    isCached = true
  ): Promise<(OtPurposesByStepsAndUser | OtPurposeByUUID)[]> {
    const uri = `/purposes/${this.userUuid}?language=${this.lang}&step=${step}`;
    const { data } = await this.request<(OtPurposesByStepsAndUser | OtPurposeByUUID)[]>(uri, {}, true, isCached);

    return data;
  }

  async getPurposesForUserByCategory(category: "all", isCached?: boolean): Promise<OtPurposesByCategoryAndUser[]>;
  async getPurposesForUserByCategory(category: Categories, isCached?: boolean): Promise<OtPurposeByUUID[]>;
  async getPurposesForUserByCategory(
    category: Categories,
    isCached = true
  ): Promise<(OtPurposesByCategoryAndUser | OtPurposeByUUID)[]> {
    const uri = `/purposes/${this.userUuid}?language=${this.lang}&category=${category}`;
    const { data } = await this.request<(OtPurposesByCategoryAndUser | OtPurposeByUUID)[]>(uri, {}, true, isCached);

    return data;
  }

  async updateUserConsentsEvo(_: ConsentPayload): Promise<void> {
    throw new Error("Consent updates via this API are not supported in CAS. This method is EVO-only.");
  }
}
